import React from "react";
import { Link, NavLink, Outlet, Navigate } from "react-router-dom";
import { usePortalAuth } from "@/portal/PortalAuth";

const LINKS = [
  { to: "/portal", end: true, label: "Dashboard" },
  { to: "/portal/lists", label: "Lists" },
  { to: "/portal/templates", label: "Templates" },
  { to: "/portal/campaigns", label: "Campaigns" },
  { to: "/portal/settings/smtp", label: "SMTP" },
];

export default function PortalLayout() {
  const { user, loading, logout, isAuthenticated } = usePortalAuth();

  if (loading) {
    return (
      <div className="portal-shell--auth">
        <p className="boot__meta">Loading portal…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace />;
  }

  return (
    <div className="portal-shell">
      <aside className="portal-nav">
        <div className="portal-nav__brand">IT-Patrol Portal</div>
        <ul className="portal-nav__links">
          {LINKS.map((link) => (
            <li key={link.to}>
              <NavLink to={link.to} end={link.end}>
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: "auto", padding: "0.5rem", fontSize: "0.8rem", color: "var(--muted)" }}>
          <div>{user.email}</div>
          <button type="button" className="btn btn--ghost" style={{ marginTop: "0.75rem", width: "100%" }} onClick={logout}>
            Sign out
          </button>
          <Link to="/" style={{ display: "block", marginTop: "0.75rem", textDecoration: "underline" }}>
            ← Public site
          </Link>
        </div>
      </aside>
      <div className="portal-main">
        <Outlet />
      </div>
    </div>
  );
}
